import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/shared/user.service';
import { MyErrorStateMatcher } from '../login/login.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../login/login.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotForm: any = FormGroup;
  matcher = new MyErrorStateMatcher();
  isLoading = false;
  constructor(public userService: UserService, private router: Router, private toast: ToastrService) {
    this.forgotForm = new FormGroup({
      emailAddress: new FormControl("", [Validators.required, Validators.email]),
    });
  }
  ngOnInit() {

  }
  async updatePassword() {
    if (this.forgotForm.valid) {
      this.isLoading = true;
      try {
        await this.userService.updatePassword(this.forgotForm.get('emailAddress').value).then((res) => {
          if(res && res == '<400 BAD_REQUEST Bad Request,Invalid Email,[]>')
            this.toast.error('Invalid Email Adrress!', '');
          else {
            this.toast.success('Password has been sent to the registered E-mail Address', '');
            this.router.navigate(['login']);
          }
          this.isLoading = false;
        })
      } catch (error) {
        this.isLoading = false;
        this.toast.error(error.error.error, '');

      }
    }
  }
}
